import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer/footer";
import StepRoutes from "../../Routes/steps_routes";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import Pagination from "../../Components/layouts/pagination";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import LoadingPage from "../../Components/layouts/loading";
import EnquiryTable from "./Enquiry/enquiry_table";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { useDispatch, useSelector } from "react-redux";
import { FcCustomerSupport } from "react-icons/fc";
import { setCurrentPage } from "../../redux/Filtered leads/enquiriesReducer";
import eqData from "../../../kisan_enquiries.json";
const Enquiry = () => {
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    leadname: "",
    leadowner: "",
  });
  const store = useSelector((store) => store.enquiriesFilters);

  const dispatch = useDispatch();
  const [page, setCurrPage] = useState(store.currentPage);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/enquiryWebhook/getEnquiry", store.currentPage, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(Math.ceil(res.data?.enquiriesCount / 50));
        } else {
          Toast("error", "Error while getting Leads!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, store.currentPage]);
  useEffect(() => {
    setCurrPage(store.currentPage);
    setShowPage(Math.floor((store.currentPage - 1) / 5) * 5 + 1);
  }, [store.currentPage]);
  const setPage = (p) => {
    dispatch(setCurrentPage(p));
  };
  if (loading) {
    return <LoadingPage />;
  }
  // const handelSubmit = async(values) => {
  //   let d = values;
  //   let fname = values.name?.trim().split(" ");
  //   if (fname.length > 1) {
  //     values = {
  //       firstName: fname[0]?.trim(),
  //       lastName: fname[fname.length - 1]?.trim(),
  //     };
  //   } else {
  //     values = {
  //       firstName: fname[0]?.trim(),
  //     };
  //   }
  //   values = {
  //     ...values,
  //     origin: "Kisan_Exhibition_2024",
  //     fullName: d?.name?.trim(),
  //     mobileNumber: d?.mobile,
  //     notes: d?.notes?.trim(),
  //   };

  //   // setLoading(true);
  //   performRequest("POST", "/enquiryWebhook/createExhibitionEnquiry", values)
  //     .then((res) => {
  //       if (res.status === 201) {
  //         Toast(
  //           "success",
  //           "Thank you for your inquiry—we'll get back to you shortly!"
  //         );
  //       } else if (res.status === 200) {
  //         Toast("error", res.data.message);
  //       } else {
  //         Toast("error", "Error while uploading");
  //       }
  //     })
  //     .catch((err) => {
  //       CustomErrorResponse(err);
  //     })
  //     .finally(() => setLoading(false));
  // };
  let falseEQData = [];
  let trueEQData = [];
  // for (let i = 0; i < eqData.length; i++) {
  //   let d = eqData[i].mobile.toString().trim();
  //   if (d.length === 10) {
  //     // trueEQData.push(eqData[i]);
  //     handelSubmit(eqData[i]);
  //   } else {
  //     falseEQData.push(eqData[i]);
  //   }
  // }
  let i = 0; // Start index
  const interval = 5000; // 5 seconds in milliseconds

  function processData() {
    if (i < eqData.length) {
      let d = eqData[i].mobile.toString().trim();
      if (d.length === 10) {
        // handelSubmit(eqData[i]); // Call submit function
      } else {
        falseEQData.push(eqData[i]); // Push to false data
      }
      i++; // Increment the index

      // Call processData again after 5 seconds
      setTimeout(processData, interval);
    } else {
    }
  }

  // Start processing
  processData();
  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title">
                    <FcCustomerSupport className="fs-2  me-1" />
                    Enquiry
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
              </div>
            </div>
          </div>

          <div className="page-body">
            <div className="container-xl">
              <div className="card">
                {data && <EnquiryTable leads={data?.enquiriesData} />}
                <Pagination
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  pageDatalength={data?.enquiriesData?.length}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Enquiry;
